module.exports = __webpack_public_path__ + "static/media/file-invoice.cfcd44c8.svg";